/**
 * vue 过滤器:uppercase
 * @param value 略
 */
export const uppercase = value => value.toUpperCase();

/**
 * vue 过滤器:lowercase
 * @param value 略
 */
export const lowercase = value => value.toLowerCase();

/**
 * vue 过滤器：money，精确到小数点两位
 * @param value 数值
 */
export const money = (value) => {
    const curVal = parseFloat(value || '0.00');
    const localV = curVal || 0.00;
    return localV.toFixed(2);
};

/**
 * vue 过滤器：格式化信息统计，大于99显示‘99+’
 */
export const parseNum = (value) => {
    const num = Number(value);
    if (!num) {
        return value;
    }
    let result = '';
    if (num) result = num.toString();
    if (num > 99) {
        result = '99+';
    }
    return result;
};

export const parseLargeNum = (value) => {
    const num = parseFloat(value || '0.00');

    let result = '';
    if (num < 10000) {
        result = num.toFixed(2);
    } else {
        const minilize = parseFloat(num / 10000);
        result = `${minilize.toFixed(2)}万`;
    }
    return result;
};

/**
 * vue 过滤器：格式化信息统计，大于99显示‘...’
 */
export const parseNumPoint = (value) => {
    const num = Number(value);
    if (!num) {
        return value;
    }
    let result = '';
    if (num) {
        result = num.toString();
    }
    if (num > 99) {
        result = '...';
    }
    return result;
};

/**
 * 手机号分割 {ddd dddd dddd}
 */
export const sliceMobile = (value) => {
    if (!value) {
        return '';
    }

    return value.replace(/\s/g, '').replace(/(^\d{3}|\d{4})(?=\d)/g, '$1 ');
};

/**
 * vue 过滤器：格式化，超过规定字符...
 */
export const overLength = (value, len) => { // value值，len长度
    if (value && value.length > len) {
        return `${value.slice(0, len)}...`;
    }
    return value;
};

/**
 * 字符串截取
 * @param {Number} start
 * @param {Number} stop
 */
export function substring(string, start, stop) {
    if (!string) return '';
    return `${string.slice(start, stop)}`;
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
    if (!+num) {
        return num !== 'undefined' ? num : '';
    }
    return num.toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * 注册过滤器
 * @param Vue Vue
 */
function registFilters(Vue) {
    Vue.filter('uppercase', uppercase);
    Vue.filter('lowercase', lowercase);
    Vue.filter('money', money);
    Vue.filter('parseNum', parseNum);
    Vue.filter('parseNumPoint', parseNumPoint);
    Vue.filter('parseLargeNum', parseLargeNum);
    Vue.filter('sliceMobile', sliceMobile);
    Vue.filter('overLength', overLength);
    Vue.filter('substring', substring);
    Vue.filter('toThousandFilter', toThousandFilter);
}

export default registFilters;



// WEBPACK FOOTER //
// ./src/utils/filters.js